import styled from "@emotion/styled"
import Typography from "@mui/material/Typography"
import { breakpoints } from "../../theme/mediaQueries"
import { sizes } from "../../theme/sizes"
import { colors } from "../../theme/colors"

export const Root = styled.div`
  width: 100%;
  padding: ${sizes.spacing[40]}px 0;
  display: flex;
  flex-direction: column;
  gap: ${sizes.spacing[16]}px;

  @media (min-width: ${breakpoints.lg}px) {
    padding: ${sizes.spacing[64]}px 0;
    gap: ${sizes.spacing[24]}px;
  }
`

export const VideoWrapper = styled.div<{ $contained?: boolean }>`
  /* EGDE-336 (design decision 2026-07-08): on MOBILE every video is an
     end-to-end full-bleed strip (breaks out of the container padding). On
     DESKTOP the video keeps margins up to the site grid — it never breaks out
     of the surrounding Container (the old 100vw breakout was wider than the
     viewport by the scrollbar and got cut). "contained" additionally caps at
     800px centred. */
  width: 100vw;
  max-width: 100vw;
  margin-inline: calc(50% - 50vw);

  @media (min-width: ${breakpoints.lg}px) {
    width: 100%;
    max-width: ${(p) => (p.$contained ? "800px" : "100%")};
    margin: 0 auto;
  }
`

export const IframeWrapper = styled.div<{ $contained?: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  /* EGDE-336: square corners against the viewport edge on mobile (full
     bleed); 40px rounded corners on desktop per the design. */
  border-radius: 0;
  background-color: ${colors.primitives.neutral200};

  @media (min-width: ${breakpoints.lg}px) {
    border-radius: ${sizes.borderRadius[40]}px;
  }

  iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: inherit;
  }
`

export const Caption = styled(Typography)`
  text-align: center;
  color: ${colors.light.text.primary};
`
